import { goTo } from 'browser-history'
import { PageId } from 'page-constants'
import { AppName, EXTERNAL_CONTACT_FORM_LINK } from 'root-constants'

export const useContactFormNavigation = () => {
  const goToContactForm = (appName?: string) => {
    if (appName === AppName.DEEPLY) {
      window.location.assign(EXTERNAL_CONTACT_FORM_LINK[AppName.DEEPLY])
      return
    }

    goTo(PageId.CONTACT_FORM)
  }

  return { goToContactForm }
}
